import React from "react";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";

const CheckoutSteps = ({ step1, step2, step3, step4 }) => {
  return (
    <Nav className="justify-content-center mb-2 bg-primary rounded">
      <Nav.Item>
        {step1 ? (
          <Nav.Link
            as={Link}
            to="/login"
            variant="dark"
            className="check-out-step"
          >
            Sign In
          </Nav.Link>
        ) : (
          <Nav.Link disabled>Sign In</Nav.Link>
        )}
      </Nav.Item>
      <Nav.Item>
        {step2 ? (
          <Nav.Link as={Link} to="/delivery" className="check-out-step">
            Delivery
          </Nav.Link>
        ) : (
          <Nav.Link disabled>Delivery</Nav.Link>
        )}
      </Nav.Item>
      <Nav.Item>
        {step3 ? (
          <Nav.Link as={Link} to="/payment" className="check-out-step">
            Payment
          </Nav.Link>
        ) : (
          <Nav.Link disabled>Payment</Nav.Link>
        )}
      </Nav.Item>
      <Nav.Item>
        {step4 ? (
          <Nav.Link as={Link} to="/placeorder" className="check-out-step">
            Place Order
          </Nav.Link>
        ) : (
          <Nav.Link disabled>Place Order</Nav.Link>
        )}
      </Nav.Item>
    </Nav>
  );
};

export default CheckoutSteps;
